module.exports = __webpack_public_path__ + "media/images/water-damage-b4602212317554aa28c10258aa895f5d.svg";